export default "/images/vendor/flag-icon-css/flags/1x1/in.svg?e626d1bb4e16e732e1ddf526206aefb3";